export const KOCH_SWIPER_A11Y = {
    enabled: false,
};
